(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cats-recipe-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.cats-recipes');
    sections.forEach(initCatsRecipes);

    function initCatsRecipes(root) {
      const sectionId = root.dataset.sectionId;
      const dataEl = document.getElementById('cats-recipes-data-' + sectionId);
      if (!dataEl) return;
      let catalog;
      try {
        catalog = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!catalog.length) return;

      const cardsWrap = document.getElementById('cats-recipes-cards-' + sectionId);
      const sizesWrap = document.getElementById('cats-recipes-sizes-' + sectionId);
      const planStep = document.getElementById('cats-recipes-plan-step-' + sectionId);
      const plansWrap = document.getElementById('cats-recipes-plans-' + sectionId);
      const summaryMedia = document.getElementById('cats-recipes-summary-media-' + sectionId);
      const summaryName = document.getElementById('cats-recipes-summary-name-' + sectionId);
      const summaryMeta = document.getElementById('cats-recipes-summary-meta-' + sectionId);
      const linesWrap = document.getElementById('cats-recipes-lines-' + sectionId);
      const totalEl = document.getElementById('cats-recipes-total-' + sectionId);
      const qtyValueEl = document.getElementById('cats-recipes-qty-' + sectionId);
      const decBtn = document.getElementById('cats-recipes-dec-' + sectionId);
      const incBtn = document.getElementById('cats-recipes-inc-' + sectionId);
      const variantInput = document.getElementById('cats-recipes-variant-id-' + sectionId);
      const quantityInput = document.getElementById('cats-recipes-quantity-input-' + sectionId);
      const sellingPlanInput = document.getElementById('cats-recipes-selling-plan-' + sectionId);
      const ctaLabel = document.getElementById('cats-recipes-cta-label-' + sectionId);
      const ctaButton = document.getElementById('ProductSubmitButton-' + sectionId);
      const shipNote = document.getElementById('cats-recipes-shipnote-' + sectionId);

      if (!cardsWrap || !sizesWrap || !planStep || !plansWrap || !summaryMedia || !summaryName
        || !summaryMeta || !linesWrap || !totalEl || !qtyValueEl || !decBtn || !incBtn
        || !variantInput || !quantityInput || !sellingPlanInput || !ctaLabel || !ctaButton || !shipNote) {
        return;
      }

      const money = (cents) => (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, window.money_format)
        : '$' + (cents / 100).toFixed(2);

      const preselectSubscription = root.dataset.preselectSubscription === 'true';
      const firstOrderNote = root.dataset.firstOrderNote || '';
      const recurringNote = root.dataset.recurringNote || '';
      const shippingNote = root.dataset.shippingNote || '';
      const hiddenSizes = (root.dataset.hiddenSizes || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
      const isHiddenSize = (size) => hiddenSizes.some((h) => String(size || '').toLowerCase().includes(h));
      const defaultPlan = preselectSubscription ? 'sub' : 'once';

      const state = { recipe: 0, size: null, plan: defaultPlan, sellingPlanId: null, qty: 1 };

      function currentRecipe() { return catalog[state.recipe]; }
      function currentVariant() {
        const recipe = currentRecipe();
        return recipe.variants.find((v) => v.size === state.size) || recipe.variants[0];
      }

      function renderSizes() {
        const recipe = currentRecipe();
        const sizes = [];
        recipe.variants.forEach((v) => {
          if (!sizes.includes(v.size) && !isHiddenSize(v.size)) sizes.push(v.size);
        });
        if (!sizes.length) recipe.variants.forEach((v) => { if (!sizes.includes(v.size)) sizes.push(v.size); });
        if (!sizes.includes(state.size)) state.size = sizes[0];

        const bestValueSize = sizes.length > 1 ? largestSize(recipe, sizes) : null;

        sizesWrap.innerHTML = '';
        sizes.forEach((size) => {
          const variant = recipe.variants.find((v) => v.size === size);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cats-recipes__size' + (state.size === size ? ' is-selected' : '');
          btn.innerHTML =
            (size === bestValueSize ? '<span class="cats-recipes__size-flag">Best value</span>' : '') +
            '<span class="cats-recipes__size-check" aria-hidden="true">&#10003;</span>' +
            '<span class="cats-recipes__size-label">' + size + '</span>' +
            '<span class="cats-recipes__size-price">' + money(variant.price) + '</span>';
          btn.addEventListener('click', () => {
            state.size = size;
            render();
          });
          sizesWrap.appendChild(btn);
        });
      }

      // Weight in grams parsed from labels like "5.5 lb", "12 oz", "1kg"; null if unparseable.
      function sizeWeight(size) {
        const match = String(size || '').match(/(\d+(?:\.\d+)?)\s*(lbs?|oz|kg|g)\b/i);
        if (!match) return null;
        const grams = { lb: 453.6, lbs: 453.6, oz: 28.35, kg: 1000, g: 1 };
        return parseFloat(match[1]) * grams[match[2].toLowerCase()];
      }

      // Biggest size by weight; falls back to the highest price when labels have no weight.
      function largestSize(recipe, sizes) {
        const weights = sizes.map(sizeWeight);
        const useWeight = weights.every((w) => w !== null);
        let best = sizes[0];
        let bestScore = -Infinity;
        sizes.forEach((size, i) => {
          const score = useWeight ? weights[i] : recipe.variants.find((v) => v.size === size).price;
          if (score > bestScore) { bestScore = score; best = size; }
        });
        return best;
      }

      function renderPlans() {
        const variant = currentVariant();
        const plans = variant.selling_plans || [];

        if (!plans.length) {
          planStep.hidden = true;
          if (state.plan === 'sub') { state.plan = 'once'; state.sellingPlanId = null; }
          return;
        }
        planStep.hidden = false;

        if (plans.length === 1) {
          state.sellingPlanId = plans[0].id;
        } else if (state.sellingPlanId && !plans.find((p) => p.id === state.sellingPlanId)) {
          state.sellingPlanId = null;
        }

        const selectedPlan = plans.find((p) => p.id === state.sellingPlanId) || plans[0];
        const savingsPct = Math.round((1 - selectedPlan.price / variant.price) * 100);

        plansWrap.innerHTML = '';

        const subCard = document.createElement('div');
        subCard.className = 'cats-recipes__plan' + (state.plan === 'sub' ? ' is-selected' : '');
        subCard.innerHTML =
          (savingsPct > 0 ? '<span class="cats-recipes__plan-flag">Most popular</span>' : '') +
          '<div class="cats-recipes__plan-row">' +
          '<span class="cats-recipes__plan-dot" aria-hidden="true"></span>' +
          '<span class="cats-recipes__plan-text"><strong>Subscribe' + (savingsPct > 0 ? ' &amp; save ' + savingsPct + '% ' + firstOrderNote : '') + '</strong>' +
          (recurringNote ? '<small>' + recurringNote + '</small>' : '') +
          (shippingNote ? '<small>' + shippingNote + '</small>' : '') + '</span>' +
          '<span class="cats-recipes__plan-price"><strong>' + money(selectedPlan.price) + '</strong>' +
          (savingsPct > 0 ? '<small class="cats-recipes__strike">' + money(variant.price) + '</small>' : '') + '</span>' +
          '</div>';
        if (plans.length > 1) {
          const freqRow = document.createElement('div');
          freqRow.className = 'cats-recipes__plan-freq';
          const select = document.createElement('select');
          select.className = 'cats-recipes__freq-select';
          select.setAttribute('aria-label', 'Delivery frequency');
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Select frequency';
          select.appendChild(placeholder);
          plans.forEach((p) => {
            const option = document.createElement('option');
            option.value = p.id;
            option.textContent = p.name;
            select.appendChild(option);
          });
          select.value = state.sellingPlanId ? String(state.sellingPlanId) : '';
          select.addEventListener('click', (e) => e.stopPropagation());
          select.addEventListener('change', () => {
            state.plan = 'sub';
            state.sellingPlanId = select.value ? Number(select.value) : null;
            render();
          });
          freqRow.appendChild(select);
          subCard.appendChild(freqRow);
        }
        subCard.addEventListener('click', () => { state.plan = 'sub'; render(); });
        plansWrap.appendChild(subCard);

        const onceRow = document.createElement('div');
        onceRow.className = 'cats-recipes__plan cats-recipes__plan--once' + (state.plan === 'once' ? ' is-selected' : '');
        onceRow.innerHTML =
          '<div class="cats-recipes__plan-row">' +
          '<span class="cats-recipes__plan-dot" aria-hidden="true"></span>' +
          '<span class="cats-recipes__plan-text"><strong>One-time purchase</strong></span>' +
          '<span class="cats-recipes__plan-price"><strong>' + money(variant.price) + '</strong></span>' +
          '</div>';
        onceRow.addEventListener('click', () => { state.plan = 'once'; render(); });
        plansWrap.appendChild(onceRow);
      }

      function renderSummary() {
        const recipe = currentRecipe();
        const variant = currentVariant();
        const plans = variant.selling_plans || [];
        const isSub = state.plan === 'sub' && plans.length > 0;
        const selectedPlan = isSub ? plans.find((p) => p.id === state.sellingPlanId) : null;
        const unitPrice = isSub && selectedPlan ? selectedPlan.price : variant.price;
        const subtotal = variant.price * state.qty;
        const discount = isSub && selectedPlan ? (variant.price - selectedPlan.price) * state.qty : 0;
        const afterDiscount = subtotal - discount;
        const freeShip = afterDiscount >= 4900;

        summaryMedia.style.background = recipe.tint;
        summaryMedia.innerHTML = recipe.image
          ? '<img src="' + recipe.image + '" alt="' + recipe.title + '" loading="lazy">'
          : '';
        summaryName.textContent = recipe.title;
        summaryMeta.textContent = (variant.size || '') + (isSub ? ' · ' + (selectedPlan ? (/^every\b/i.test(selectedPlan.name) ? selectedPlan.name : 'Every ' + selectedPlan.name) : 'Subscription') : ' · One-time');

        linesWrap.innerHTML =
          '<div class="cats-recipes__summary-row"><span>Subtotal</span><span>' + money(subtotal) + '</span></div>' +
          (discount > 0 ? '<div class="cats-recipes__summary-row cats-recipes__summary-row--discount"><span>Subscription savings</span><span>&minus;' + money(discount) + '</span></div>' : '') +
          '<div class="cats-recipes__summary-row"><span>Shipping</span><span>' + (freeShip ? 'Free' : 'Calculated at checkout') + '</span></div>';

        totalEl.textContent = money(afterDiscount);
        shipNote.textContent = freeShip
          ? 'You’ve unlocked free shipping.'
          : 'Add ' + money(4900 - afterDiscount) + ' more for free shipping.';

        variantInput.value = variant.id;
        quantityInput.value = state.qty;
        if (isSub && selectedPlan) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = selectedPlan.id;
        } else {
          sellingPlanInput.disabled = true;
          sellingPlanInput.value = '';
        }

        if (isSub && !selectedPlan) {
          ctaButton.setAttribute('aria-disabled', 'true');
          ctaLabel.textContent = 'Select a frequency';
        } else if (variant.available) {
          ctaButton.removeAttribute('aria-disabled');
          ctaLabel.textContent = isSub ? 'Subscribe & add to cart' : 'Add to cart';
        } else {
          ctaButton.setAttribute('aria-disabled', 'true');
          ctaLabel.textContent = 'Sold out';
        }

        qtyValueEl.textContent = state.qty;
      }

      function render() {
        renderSizes();
        renderPlans();
        renderSummary();
      }

      if (cardsWrap) {
        cardsWrap.addEventListener('click', (e) => {
          const card = e.target.closest('.cats-recipes__card');
          if (!card) return;
          const index = parseInt(card.dataset.recipeIndex, 10);
          if (Number.isNaN(index) || index === state.recipe) return;
          state.recipe = index;
          state.size = null;
          state.plan = defaultPlan;
          state.sellingPlanId = null;
          cardsWrap.querySelectorAll('.cats-recipes__card').forEach((btn, i) => {
            btn.classList.toggle('is-selected', i === index);
            btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
          });
          render();
        });
      }

      decBtn.addEventListener('click', () => {
        state.qty = Math.max(1, state.qty - 1);
        renderSummary();
      });
      incBtn.addEventListener('click', () => {
        state.qty = Math.min(12, state.qty + 1);
        renderSummary();
      });

      render();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogs-recipe-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.dogs-recipes');
    sections.forEach(initDogsRecipes);

    function initDogsRecipes(root) {
      const sectionId = root.dataset.sectionId;
      const dataEl = document.getElementById('dogs-recipes-data-' + sectionId);
      if (!dataEl) return;
      let catalog;
      try {
        catalog = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!catalog.length) return;

      const cardsWrap = document.getElementById('dogs-recipes-cards-' + sectionId);
      const sizesWrap = document.getElementById('dogs-recipes-sizes-' + sectionId);
      const planStep = document.getElementById('dogs-recipes-plan-step-' + sectionId);
      const plansWrap = document.getElementById('dogs-recipes-plans-' + sectionId);
      const summaryMedia = document.getElementById('dogs-recipes-summary-media-' + sectionId);
      const summaryName = document.getElementById('dogs-recipes-summary-name-' + sectionId);
      const summaryMeta = document.getElementById('dogs-recipes-summary-meta-' + sectionId);
      const linesWrap = document.getElementById('dogs-recipes-lines-' + sectionId);
      const totalEl = document.getElementById('dogs-recipes-total-' + sectionId);
      const qtyValueEl = document.getElementById('dogs-recipes-qty-' + sectionId);
      const decBtn = document.getElementById('dogs-recipes-dec-' + sectionId);
      const incBtn = document.getElementById('dogs-recipes-inc-' + sectionId);
      const variantInput = document.getElementById('dogs-recipes-variant-id-' + sectionId);
      const quantityInput = document.getElementById('dogs-recipes-quantity-input-' + sectionId);
      const sellingPlanInput = document.getElementById('dogs-recipes-selling-plan-' + sectionId);
      const ctaLabel = document.getElementById('dogs-recipes-cta-label-' + sectionId);
      const ctaButton = document.getElementById('ProductSubmitButton-' + sectionId);
      const shipNote = document.getElementById('dogs-recipes-shipnote-' + sectionId);

      if (!cardsWrap || !sizesWrap || !planStep || !plansWrap || !summaryMedia || !summaryName
        || !summaryMeta || !linesWrap || !totalEl || !qtyValueEl || !decBtn || !incBtn
        || !variantInput || !quantityInput || !sellingPlanInput || !ctaLabel || !ctaButton || !shipNote) {
        return;
      }

      const money = (cents) => (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, window.money_format)
        : '$' + (cents / 100).toFixed(2);

      const preselectSubscription = root.dataset.preselectSubscription === 'true';
      const firstOrderNote = root.dataset.firstOrderNote || '';
      const recurringNote = root.dataset.recurringNote || '';
      const shippingNote = root.dataset.shippingNote || '';
      const hiddenSizes = (root.dataset.hiddenSizes || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
      const isHiddenSize = (size) => hiddenSizes.some((h) => String(size || '').toLowerCase().includes(h));
      const defaultPlan = preselectSubscription ? 'sub' : 'once';

      const state = { recipe: 0, size: null, plan: defaultPlan, sellingPlanId: null, qty: 1 };

      function currentRecipe() { return catalog[state.recipe]; }
      function currentVariant() {
        const recipe = currentRecipe();
        return recipe.variants.find((v) => v.size === state.size) || recipe.variants[0];
      }

      function renderSizes() {
        const recipe = currentRecipe();
        const sizes = [];
        recipe.variants.forEach((v) => {
          if (!sizes.includes(v.size) && !isHiddenSize(v.size)) sizes.push(v.size);
        });
        if (!sizes.length) recipe.variants.forEach((v) => { if (!sizes.includes(v.size)) sizes.push(v.size); });
        if (!sizes.includes(state.size)) state.size = sizes[0];

        const bestValueSize = sizes.length > 1 ? largestSize(recipe, sizes) : null;

        sizesWrap.innerHTML = '';
        sizes.forEach((size) => {
          const variant = recipe.variants.find((v) => v.size === size);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'dogs-recipes__size' + (state.size === size ? ' is-selected' : '');
          btn.innerHTML =
            (size === bestValueSize ? '<span class="dogs-recipes__size-flag">Best value</span>' : '') +
            '<span class="dogs-recipes__size-check" aria-hidden="true">&#10003;</span>' +
            '<span class="dogs-recipes__size-label">' + size + '</span>' +
            '<span class="dogs-recipes__size-price">' + money(variant.price) + '</span>';
          btn.addEventListener('click', () => {
            state.size = size;
            render();
          });
          sizesWrap.appendChild(btn);
        });
      }

      // Weight in grams parsed from labels like "5.5 lb", "12 oz", "1kg"; null if unparseable.
      function sizeWeight(size) {
        const match = String(size || '').match(/(\d+(?:\.\d+)?)\s*(lbs?|oz|kg|g)\b/i);
        if (!match) return null;
        const grams = { lb: 453.6, lbs: 453.6, oz: 28.35, kg: 1000, g: 1 };
        return parseFloat(match[1]) * grams[match[2].toLowerCase()];
      }

      // Biggest size by weight; falls back to the highest price when labels have no weight.
      function largestSize(recipe, sizes) {
        const weights = sizes.map(sizeWeight);
        const useWeight = weights.every((w) => w !== null);
        let best = sizes[0];
        let bestScore = -Infinity;
        sizes.forEach((size, i) => {
          const score = useWeight ? weights[i] : recipe.variants.find((v) => v.size === size).price;
          if (score > bestScore) { bestScore = score; best = size; }
        });
        return best;
      }

      function renderPlans() {
        const variant = currentVariant();
        const plans = variant.selling_plans || [];

        if (!plans.length) {
          planStep.hidden = true;
          if (state.plan === 'sub') { state.plan = 'once'; state.sellingPlanId = null; }
          return;
        }
        planStep.hidden = false;

        if (plans.length === 1) {
          state.sellingPlanId = plans[0].id;
        } else if (state.sellingPlanId && !plans.find((p) => p.id === state.sellingPlanId)) {
          state.sellingPlanId = null;
        }

        const selectedPlan = plans.find((p) => p.id === state.sellingPlanId) || plans[0];
        const savingsPct = Math.round((1 - selectedPlan.price / variant.price) * 100);

        plansWrap.innerHTML = '';

        const subCard = document.createElement('div');
        subCard.className = 'dogs-recipes__plan' + (state.plan === 'sub' ? ' is-selected' : '');
        subCard.innerHTML =
          (savingsPct > 0 ? '<span class="dogs-recipes__plan-flag">Most popular</span>' : '') +
          '<div class="dogs-recipes__plan-row">' +
          '<span class="dogs-recipes__plan-dot" aria-hidden="true"></span>' +
          '<span class="dogs-recipes__plan-text"><strong>Subscribe' + (savingsPct > 0 ? ' &amp; save ' + savingsPct + '% ' + firstOrderNote : '') + '</strong>' +
          (recurringNote ? '<small>' + recurringNote + '</small>' : '') +
          (shippingNote ? '<small>' + shippingNote + '</small>' : '') + '</span>' +
          '<span class="dogs-recipes__plan-price"><strong>' + money(selectedPlan.price) + '</strong>' +
          (savingsPct > 0 ? '<small class="dogs-recipes__strike">' + money(variant.price) + '</small>' : '') + '</span>' +
          '</div>';
        if (plans.length > 1) {
          const freqRow = document.createElement('div');
          freqRow.className = 'dogs-recipes__plan-freq';
          const select = document.createElement('select');
          select.className = 'dogs-recipes__freq-select';
          select.setAttribute('aria-label', 'Delivery frequency');
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Select frequency';
          select.appendChild(placeholder);
          plans.forEach((p) => {
            const option = document.createElement('option');
            option.value = p.id;
            option.textContent = p.name;
            select.appendChild(option);
          });
          select.value = state.sellingPlanId ? String(state.sellingPlanId) : '';
          select.addEventListener('click', (e) => e.stopPropagation());
          select.addEventListener('change', () => {
            state.plan = 'sub';
            state.sellingPlanId = select.value ? Number(select.value) : null;
            render();
          });
          freqRow.appendChild(select);
          subCard.appendChild(freqRow);
        }
        subCard.addEventListener('click', () => { state.plan = 'sub'; render(); });
        plansWrap.appendChild(subCard);

        const onceRow = document.createElement('div');
        onceRow.className = 'dogs-recipes__plan dogs-recipes__plan--once' + (state.plan === 'once' ? ' is-selected' : '');
        onceRow.innerHTML =
          '<div class="dogs-recipes__plan-row">' +
          '<span class="dogs-recipes__plan-dot" aria-hidden="true"></span>' +
          '<span class="dogs-recipes__plan-text"><strong>One-time purchase</strong></span>' +
          '<span class="dogs-recipes__plan-price"><strong>' + money(variant.price) + '</strong></span>' +
          '</div>';
        onceRow.addEventListener('click', () => { state.plan = 'once'; render(); });
        plansWrap.appendChild(onceRow);
      }

      function renderSummary() {
        const recipe = currentRecipe();
        const variant = currentVariant();
        const plans = variant.selling_plans || [];
        const isSub = state.plan === 'sub' && plans.length > 0;
        const selectedPlan = isSub ? plans.find((p) => p.id === state.sellingPlanId) : null;
        const unitPrice = isSub && selectedPlan ? selectedPlan.price : variant.price;
        const subtotal = variant.price * state.qty;
        const discount = isSub && selectedPlan ? (variant.price - selectedPlan.price) * state.qty : 0;
        const afterDiscount = subtotal - discount;
        const freeShip = afterDiscount >= 4900;

        summaryMedia.style.background = recipe.tint;
        summaryMedia.innerHTML = recipe.image
          ? '<img src="' + recipe.image + '" alt="' + recipe.title + '" loading="lazy">'
          : '';
        summaryName.textContent = recipe.title;
        summaryMeta.textContent = (variant.size || '') + (isSub ? ' · ' + (selectedPlan ? (/^every\b/i.test(selectedPlan.name) ? selectedPlan.name : 'Every ' + selectedPlan.name) : 'Subscription') : ' · One-time');

        linesWrap.innerHTML =
          '<div class="dogs-recipes__summary-row"><span>Subtotal</span><span>' + money(subtotal) + '</span></div>' +
          (discount > 0 ? '<div class="dogs-recipes__summary-row dogs-recipes__summary-row--discount"><span>Subscription savings</span><span>&minus;' + money(discount) + '</span></div>' : '') +
          '<div class="dogs-recipes__summary-row"><span>Shipping</span><span>' + (freeShip ? 'Free' : 'Calculated at checkout') + '</span></div>';

        totalEl.textContent = money(afterDiscount);
        shipNote.textContent = freeShip
          ? 'You’ve unlocked free shipping.'
          : 'Add ' + money(4900 - afterDiscount) + ' more for free shipping.';

        variantInput.value = variant.id;
        quantityInput.value = state.qty;
        if (isSub && selectedPlan) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = selectedPlan.id;
        } else {
          sellingPlanInput.disabled = true;
          sellingPlanInput.value = '';
        }

        if (isSub && !selectedPlan) {
          ctaButton.setAttribute('aria-disabled', 'true');
          ctaLabel.textContent = 'Select a frequency';
        } else if (variant.available) {
          ctaButton.removeAttribute('aria-disabled');
          ctaLabel.textContent = isSub ? 'Subscribe & add to cart' : 'Add to cart';
        } else {
          ctaButton.setAttribute('aria-disabled', 'true');
          ctaLabel.textContent = 'Sold out';
        }

        qtyValueEl.textContent = state.qty;
      }

      function render() {
        renderSizes();
        renderPlans();
        renderSummary();
      }

      if (cardsWrap) {
        cardsWrap.addEventListener('click', (e) => {
          const card = e.target.closest('.dogs-recipes__card');
          if (!card) return;
          const index = parseInt(card.dataset.recipeIndex, 10);
          if (Number.isNaN(index) || index === state.recipe) return;
          state.recipe = index;
          state.size = null;
          state.plan = defaultPlan;
          state.sellingPlanId = null;
          cardsWrap.querySelectorAll('.dogs-recipes__card').forEach((btn, i) => {
            btn.classList.toggle('is-selected', i === index);
            btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
          });
          render();
        });
      }

      decBtn.addEventListener('click', () => {
        state.qty = Math.max(1, state.qty - 1);
        renderSummary();
      });
      incBtn.addEventListener('click', () => {
        state.qty = Math.min(12, state.qty + 1);
        renderSummary();
      });

      render();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-smack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.smack-pdp');
    sections.forEach(initSmackPdp);

    function initSmackPdp(root) {
      const sectionId = root.dataset.sectionId;
      const dataEl = root.querySelector('[data-smack-pdp-data]');
      if (!dataEl) return;
      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!data.variants || !data.variants.length) return;

      const sticky = document.querySelector(`[data-sticky][data-sticky-section-id="${sectionId}"]`);

      const els = {
        gallery: root.querySelector('[data-gallery]'),
        slides: Array.from(root.querySelectorAll('[data-slide]')),
        thumbs: Array.from(root.querySelectorAll('[data-gallery-thumb]')),
        prev: root.querySelector('[data-gallery-prev]'),
        next: root.querySelector('[data-gallery-next]'),
        optionGroups: Array.from(root.querySelectorAll('[data-option-group]')),
        pillPrices: Array.from(root.querySelectorAll('[data-pill-price]')),
        purchaseWrap: root.querySelector('[data-purchase-wrap]'),
        planCards: Array.from(root.querySelectorAll('[data-plan-card]')),
        planDetail: root.querySelector('[data-plan-detail]'),
        planSave: root.querySelector('[data-plan-save]'),
        planWas: root.querySelector('[data-plan-was]'),
        planNow: root.querySelector('[data-plan-now]'),
        planFreq: root.querySelector('[data-plan-freq]'),
        oncePrice: root.querySelector('[data-once-price]'),
        freqs: root.querySelector('[data-freqs]'),
        nudge: root.querySelector('[data-nudge]'),
        nudgeText: root.querySelector('[data-nudge-text]'),
        simplePrice: root.querySelector('[data-simple-price]'),
        priceNow: root.querySelector('[data-price-now]'),
        priceWas: root.querySelector('[data-price-was]'),
        qtyValue: root.querySelector('[data-qty-value]'),
        qtyDec: root.querySelector('[data-qty-dec]'),
        qtyInc: root.querySelector('[data-qty-inc]'),
        variantInput: root.querySelector('[data-variant-id-input]'),
        quantityInput: root.querySelector('[data-quantity-input]'),
        sellingPlanInput: root.querySelector('[data-selling-plan-input]'),
        atcButton: root.querySelector('[data-atc-button]'),
        atcLabel: root.querySelector('[data-atc-label]'),
        shipnote: root.querySelector('[data-shipnote]'),
        cutoff: root.querySelector('[data-cutoff]'),
        shipday: root.querySelector('[data-shipday]'),
        shipprogress: root.querySelector('[data-shipprogress]'),
        buyrow: root.querySelector('[data-buyrow]'),
        accordionItems: Array.from(root.querySelectorAll('[data-accordion-item]')),
      };

      const money = (cents) => (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, data.moneyFormat)
        : '$' + (cents / 100).toFixed(2);

      const maxQty = parseInt(root.dataset.maxQty, 10) || 12;
      const cutoffHour = parseInt(root.dataset.cutoffHour, 10);
      const freeShipThreshold = parseInt(root.dataset.freeShippingThreshold, 10) || 0;
      const shipTodayLabel = root.dataset.shipToday || 'today';
      const shipTomorrowLabel = root.dataset.shipTomorrow || 'tomorrow';
      const subscribeLabel = root.dataset.subscribeLabel || 'Subscribe';
      const onetimeLabel = root.dataset.onetimeLabel || 'One-time purchase';
      const addToCartLabel = root.dataset.addToCartLabel || 'Add to cart';

      function defaultPlan(plans) {
        return plans.find((p) => /most\s*common/i.test(p.name))
          || plans.find((p) => /\b4\s*-?\s*weeks?\b/i.test(p.name))
          || plans[0];
      }

      const startVariant = data.variants.find((v) => String(v.id) === String(data.currentVariantId)) || data.variants[0];

      const state = {
        selectedOptions: startVariant.options.slice(),
        plan: 'once',
        sellingPlanId: null,
        qty: 1,
      };

      if (els.planCards.length && startVariant.sellingPlans.length) {
        state.plan = 'sub';
        state.sellingPlanId = defaultPlan(startVariant.sellingPlans).id;
      }

      function currentVariant() {
        const match = data.variants.find((v) =>
          v.options.every((val, i) => val === state.selectedOptions[i])
        );
        return match || startVariant;
      }

      function renderOptions(variant) {
        els.optionGroups.forEach((group) => {
          const index = parseInt(group.dataset.optionIndex, 10);
          const current = group.querySelector('[data-option-current]');
          if (current) current.textContent = state.selectedOptions[index];
          group.querySelectorAll('[data-option-value]').forEach((btn) => {
            btn.classList.toggle('is-selected', btn.dataset.value === state.selectedOptions[index]);
          });
        });
      }

      function renderPillPrices() {
        if (!els.pillPrices.length) return;
        els.pillPrices.forEach((priceEl) => {
          const btn = priceEl.closest('[data-pill-variant-id]');
          if (!btn) return;
          const pillVariant = data.variants.find((v) => String(v.id) === String(btn.dataset.pillVariantId));
          if (!pillVariant) return;
          const plans = pillVariant.sellingPlans || [];
          const selectedPlan = state.plan === 'sub' ? (plans.find((p) => p.id === state.sellingPlanId) || plans[0]) : null;
          const unitPrice = selectedPlan ? selectedPlan.price : pillVariant.price;
          priceEl.textContent = money(unitPrice);
        });
      }

      function renderGallery(variant) {
        if (!variant.featuredMediaId || !els.slides.length) return;
        const index = els.slides.findIndex((s) => String(s.dataset.mediaId) === String(variant.featuredMediaId));
        if (index > -1) setActiveSlide(index);
      }

      function setActiveSlide(index) {
        els.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        els.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-selected', i === index));
      }

      function activeSlideIndex() {
        const active = els.slides.findIndex((s) => s.classList.contains('is-active'));
        return active > -1 ? active : 0;
      }

      function renderPlans(variant) {
        const plans = variant.sellingPlans || [];

        if (!els.purchaseWrap) return;

        if (!plans.length) {
          els.purchaseWrap.hidden = true;
          if (els.simplePrice) els.simplePrice.hidden = false;
          state.plan = 'once';
          state.sellingPlanId = null;
          return;
        }

        els.purchaseWrap.hidden = false;
        if (els.simplePrice) els.simplePrice.hidden = true;

        if (!state.sellingPlanId || !plans.find((p) => p.id === state.sellingPlanId)) {
          state.sellingPlanId = defaultPlan(plans).id;
        }

        const selectedPlan = plans.find((p) => p.id === state.sellingPlanId) || plans[0];
        const savingsPct = Math.max(0, Math.round((1 - selectedPlan.price / variant.price) * 100));

        if (els.planSave) {
          if (savingsPct > 0) {
            els.planSave.hidden = false;
            els.planSave.textContent = 'Save ' + savingsPct + '%';
          } else {
            els.planSave.hidden = true;
          }
        }
        if (els.planWas) els.planWas.textContent = savingsPct > 0 ? money(variant.price) : '';
        if (els.planNow) els.planNow.textContent = money(selectedPlan.price);
        if (els.planFreq) {
          const freqName = selectedPlan.name.toUpperCase();
          els.planFreq.textContent = freqName.indexOf('EVERY') === -1 ? 'EVERY ' + freqName : freqName;
        }
        if (els.oncePrice) els.oncePrice.textContent = money(variant.price);

        els.planCards.forEach((card) => {
          card.classList.toggle('is-selected', card.dataset.planCard === state.plan);
        });
        if (els.planDetail) els.planDetail.hidden = state.plan !== 'sub';

        if (els.freqs) {
          els.freqs.innerHTML = '';
          if (plans.length > 1) {
            plans.forEach((p) => {
              const chip = document.createElement('button');
              chip.type = 'button';
              chip.className = 'smack-pdp__freq-chip' + (p.id === state.sellingPlanId ? ' is-selected' : '');
              chip.innerHTML = '<span>' + p.name + '</span>';
              chip.addEventListener('click', (e) => {
                e.stopPropagation();
                state.plan = 'sub';
                state.sellingPlanId = p.id;
                render();
              });
              els.freqs.appendChild(chip);
            });
          }
        }

        if (els.nudge && els.nudgeText) {
          if (state.plan === 'once') {
            els.nudge.hidden = false;
            els.nudgeText.innerHTML = root.dataset.nudgeTemplate
              ? root.dataset.nudgeTemplate.replace('{plan}', subscribeLabel).replace('{price}', money(selectedPlan.price))
              : 'Switch to ' + subscribeLabel + ' — pay <strong>' + money(selectedPlan.price) + '</strong> + free gifts along the way';
          } else {
            els.nudge.hidden = true;
          }
        }
      }

      function renderPrice(variant) {
        if (!els.priceNow) return;
        els.priceNow.textContent = money(variant.price);
        if (els.priceWas) {
          els.priceWas.textContent = variant.compareAtPrice > variant.price ? money(variant.compareAtPrice) : '';
          els.priceWas.hidden = !(variant.compareAtPrice > variant.price);
        }
      }

      function renderBuy(variant) {
        const plans = variant.sellingPlans || [];
        const isSub = state.plan === 'sub' && plans.length > 0;
        const selectedPlan = isSub ? (plans.find((p) => p.id === state.sellingPlanId) || plans[0]) : null;
        const unitPrice = isSub && selectedPlan ? selectedPlan.price : variant.price;
        const total = unitPrice * state.qty;

        if (els.variantInput) els.variantInput.value = variant.id;
        if (els.quantityInput) els.quantityInput.value = state.qty;
        if (els.sellingPlanInput) {
          if (isSub && selectedPlan) {
            els.sellingPlanInput.disabled = false;
            els.sellingPlanInput.value = selectedPlan.id;
          } else {
            els.sellingPlanInput.disabled = true;
            els.sellingPlanInput.value = '';
          }
        }

        if (els.qtyValue) els.qtyValue.textContent = state.qty;

        const label = !variant.available
          ? (document.querySelector('[data-sold-out-label]')?.textContent || 'Sold out')
          : (isSub ? subscribeLabel : addToCartLabel) + ' · ' + money(total);

        if (els.atcLabel) els.atcLabel.textContent = label;
        if (els.atcButton) {
          if (!variant.available) {
            els.atcButton.setAttribute('aria-disabled', 'true');
          } else {
            els.atcButton.removeAttribute('aria-disabled');
          }
        }

        if (sticky) {
          const stickyMeta = sticky.querySelector('[data-sticky-meta]');
          if (stickyMeta) {
            stickyMeta.textContent = (isSub ? subscribeLabel : onetimeLabel) + ' · ' + money(unitPrice);
          }
          const stickyLabel = sticky.querySelector('[data-sticky-atc-label]');
          if (stickyLabel) stickyLabel.textContent = label;
          const stickyImg = sticky.querySelector('[data-sticky-media] img');
          const activeImg = els.slides[activeSlideIndex()] && els.slides[activeSlideIndex()].querySelector('img');
          if (stickyImg && activeImg) stickyImg.src = activeImg.currentSrc || activeImg.src;
        }

        if (els.shipprogress) {
          const freeShip = freeShipThreshold > 0 && total >= freeShipThreshold;
          if (freeShip) {
            els.shipprogress.textContent = '✓ You’ve unlocked free shipping';
          } else if (freeShipThreshold > 0) {
            els.shipprogress.textContent = 'Add ' + money(freeShipThreshold - total) + ' more for free shipping';
          } else {
            els.shipprogress.textContent = '';
          }
        }
      }

      function render() {
        const variant = currentVariant();
        renderOptions(variant);
        renderGallery(variant);
        renderPlans(variant);
        renderPrice(variant);
        renderBuy(variant);
        renderPillPrices();
      }

      root.addEventListener('click', (e) => {
        const optionBtn = e.target.closest('[data-option-value]');
        if (optionBtn) {
          const index = parseInt(optionBtn.dataset.optionIndex, 10);
          state.selectedOptions[index] = optionBtn.dataset.value;
          render();
          return;
        }
        const planCard = e.target.closest('[data-plan-card]');
        if (planCard) {
          state.plan = planCard.dataset.planCard === 'sub' ? 'sub' : 'once';
          render();
          return;
        }
        const nudge = e.target.closest('[data-nudge]');
        if (nudge) {
          state.plan = 'sub';
          render();
        }
      });

      if (els.qtyInc) {
        els.qtyInc.addEventListener('click', () => {
          state.qty = Math.min(maxQty, state.qty + 1);
          render();
        });
      }
      if (els.qtyDec) {
        els.qtyDec.addEventListener('click', () => {
          state.qty = Math.max(1, state.qty - 1);
          render();
        });
      }

      if (els.slides.length > 1) {
        if (els.prev) {
          els.prev.addEventListener('click', () => {
            const n = els.slides.length;
            setActiveSlide((activeSlideIndex() + n - 1) % n);
          });
        }
        if (els.next) {
          els.next.addEventListener('click', () => {
            const n = els.slides.length;
            setActiveSlide((activeSlideIndex() + 1) % n);
          });
        }
        els.thumbs.forEach((thumb, i) => {
          thumb.addEventListener('click', () => setActiveSlide(i));
        });
        let touchX = null;
        if (els.gallery) {
          els.gallery.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
          els.gallery.addEventListener('touchend', (e) => {
            if (touchX === null) return;
            const dx = e.changedTouches[0].clientX - touchX;
            const n = els.slides.length;
            if (Math.abs(dx) > 40) setActiveSlide((activeSlideIndex() + (dx < 0 ? 1 : n - 1)) % n);
            touchX = null;
          }, { passive: true });
        }
      }

      if (els.accordionItems.length) {
        els.accordionItems.forEach((item) => {
          const trigger = item.querySelector('[data-accordion-trigger]');
          const panel = item.querySelector('[data-accordion-panel]');
          if (!trigger || !panel) return;
          trigger.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');
            els.accordionItems.forEach((other) => other.classList.remove('is-open'));
            if (!isOpen) item.classList.add('is-open');
          });
        });
      }

      if (!Number.isNaN(cutoffHour) && els.cutoff && els.shipday) {
        const tick = () => {
          const now = new Date();
          const cut = new Date(now);
          cut.setHours(cutoffHour, 0, 0, 0);
          let shipDay = shipTodayLabel;
          if (now >= cut) {
            cut.setDate(cut.getDate() + 1);
            shipDay = shipTomorrowLabel;
          }
          const diff = Math.max(0, Math.floor((cut - now) / 1000));
          const p2 = (n) => String(n).padStart(2, '0');
          els.cutoff.textContent = p2(Math.floor(diff / 3600)) + ':' + p2(Math.floor(diff / 60) % 60) + ':' + p2(diff % 60);
          els.shipday.textContent = shipDay;
        };
        tick();
        setInterval(tick, 1000);
      }

      if (sticky && els.buyrow && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.hidden = !scrolledPast;
            sticky.classList.toggle('is-visible', scrolledPast);
          });
        }, { threshold: 0 });
        observer.observe(els.buyrow);
      }

      render();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smack-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatMoney(cents, format) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, format);
      const fmt = format || '$' + '{' + '{amount}}';
      const withDelims = (n, decimals, thousands, decimal) => {
        const parts = (n / 100).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
          default: return withDelims(cents, 2, ',', '.');
        }
      });
    }

    function defaultPlan(plans) {
      return plans.find((p) => /most\s*common/i.test(p.name))
        || plans.find((p) => /\b4\s*-?\s*weeks?\b/i.test(p.name))
        || plans[0];
    }

    function init(root) {
      if (root.dataset.qbReady) return;
      root.dataset.qbReady = 'true';

      const modal = root.querySelector('[data-quick-buy-modal]');
      if (!modal) return;
      const q = (sel) => modal.querySelector(sel);
      const els = {
        panel: q('.smack-qb__panel'),
        image: q('[data-qb-image]'),
        title: q('[data-qb-title]'),
        price: q('[data-qb-price]'),
        options: q('[data-qb-options]'),
        plans: q('[data-qb-plans]'),
        planSub: q('[data-qb-plan-sub]'),
        planOnce: q('[data-qb-plan-once]'),
        save: q('[data-qb-save]'),
        subPrice: q('[data-qb-sub-price]'),
        oncePrice: q('[data-qb-once-price]'),
        freq: q('[data-qb-freq]'),
        freqSelect: q('[data-qb-freq-select]'),
        qtyValue: q('[data-qb-qty-value]'),
        submit: q('[data-qb-submit]'),
        submitLabel: q('[data-qb-submit-label]'),
        error: q('[data-qb-error]'),
        details: q('[data-qb-details]'),
      };
      const moneyFormat = modal.dataset.moneyFormat;
      const addLabel = modal.dataset.addButtonLabel || 'Add to cart';
      const subscribeLabel = modal.dataset.subscribeButtonLabel || 'Subscribe';
      const soldOutLabel = modal.dataset.soldOutLabel || 'Sold out';
      const money = (c) => formatMoney(c, moneyFormat);

      let product = null;
      let opener = null;
      const state = { options: [], plan: 'once', sellingPlanId: null, qty: 1 };

      const currentVariant = () =>
        product.variants.find((v) => v.options.every((val, i) => val === state.options[i])) || product.variants[0];

      function renderOptions() {
        els.options.innerHTML = '';
        if (product.hasOnlyDefaultVariant) return;
        product.options.forEach((name, index) => {
          const group = document.createElement('div');
          group.className = 'smack-qb__option';
          const label = document.createElement('div');
          label.className = 'smack-qb__option-label';
          label.textContent = name;
          group.appendChild(label);
          const pills = document.createElement('div');
          pills.className = 'smack-qb__pills';
          const values = [...new Set(product.variants.map((v) => v.options[index]))];
          values.forEach((value) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'smack-qb__pill';
            btn.textContent = value;
            btn.dataset.index = index;
            btn.dataset.value = value;
            pills.appendChild(btn);
          });
          group.appendChild(pills);
          els.options.appendChild(group);
        });
      }

      function update() {
        const variant = currentVariant();
        const plans = variant.sellingPlans || [];
        const canSubscribe = plans.length > 0;
        const canOnce = !product.requiresSellingPlan;

        if (!canSubscribe) state.plan = 'once';
        if (!canOnce && canSubscribe) state.plan = 'sub';
        if (state.plan === 'sub' && !plans.some((p) => p.id === state.sellingPlanId)) {
          state.sellingPlanId = defaultPlan(plans).id;
        }
        const isSub = state.plan === 'sub' && canSubscribe;
        const selectedPlan = isSub ? plans.find((p) => p.id === state.sellingPlanId) : null;

        // Pills
        els.options.querySelectorAll('.smack-qb__pill').forEach((btn) => {
          const index = Number(btn.dataset.index);
          const active = state.options[index] === btn.dataset.value;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active);
          const candidate = state.options.slice();
          candidate[index] = btn.dataset.value;
          const match = product.variants.find((v) => v.options.every((val, i) => val === candidate[i]));
          btn.classList.toggle('is-unavailable', !match || !match.available);
        });

        // Plans
        els.plans.hidden = !canSubscribe;
        els.planSub.hidden = !canSubscribe;
        els.planOnce.hidden = !canOnce;
        els.planSub.classList.toggle('is-active', isSub);
        els.planOnce.classList.toggle('is-active', !isSub);
        els.planSub.querySelector('input').checked = isSub;
        els.planOnce.querySelector('input').checked = !isSub;
        els.freq.hidden = !isSub || plans.length < 2;

        if (canSubscribe) {
          const shownPlan = selectedPlan || plans[0];
          els.subPrice.textContent = money(shownPlan.price);
          els.oncePrice.textContent = money(variant.price);
          const savePct = variant.price > 0 ? Math.round((1 - shownPlan.price / variant.price) * 100) : 0;
          els.save.hidden = savePct <= 0;
          els.save.textContent = savePct > 0 ? `Save ${savePct}%` : '';
          els.freqSelect.innerHTML = plans
            .map((p) => `<option value="${p.id}"${p.id === state.sellingPlanId ? ' selected' : ''}></option>`)
            .join('');
          [...els.freqSelect.options].forEach((opt, i) => { opt.textContent = plans[i].name; });
        }

        // Price + image
        const unitPrice = selectedPlan ? selectedPlan.price : variant.price;
        els.price.textContent = money(unitPrice);
        const img = variant.image || product.image;
        els.image.hidden = !img;
        if (img) { els.image.src = img; els.image.alt = product.title; }

        // Button
        els.qtyValue.textContent = state.qty;
        if (!variant.available) {
          els.submitLabel.textContent = soldOutLabel;
          els.submit.disabled = true;
        } else {
          els.submitLabel.textContent = `${isSub ? subscribeLabel : addLabel} · ${money(unitPrice * state.qty)}`;
          els.submit.disabled = false;
        }
      }

      function open(data, btn) {
        product = data;
        opener = btn;
        const start = product.variants.find((v) => v.available) || product.variants[0];
        state.options = start.options.slice();
        state.qty = 1;
        state.plan = start.sellingPlans.length ? 'sub' : 'once';
        state.sellingPlanId = start.sellingPlans.length ? defaultPlan(start.sellingPlans).id : null;
        els.title.textContent = product.title;
        els.title.href = product.url;
        els.details.href = product.url;
        els.error.hidden = true;
        renderOptions();
        update();
        modal.hidden = false;
        document.documentElement.classList.add('smack-qb-open');
        els.panel.focus();
      }

      function close() {
        modal.hidden = true;
        document.documentElement.classList.remove('smack-qb-open');
        if (opener) opener.focus();
      }

      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-quick-buy]');
        if (!btn || btn.disabled) return;
        const json = btn.closest('.smack-cross-sell__card')?.querySelector('[data-quick-buy-product]');
        if (!json) return;
        try {
          open(JSON.parse(json.textContent), btn);
        } catch (err) {
          console.error('Smack quick buy: invalid product data', err);
        }
      });

      modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-quick-buy-close]')) return close();
        const pill = e.target.closest('.smack-qb__pill');
        if (pill) {
          state.options[Number(pill.dataset.index)] = pill.dataset.value;
          return update();
        }
        const qtyBtn = e.target.closest('[data-qb-qty]');
        if (qtyBtn) {
          state.qty = Math.min(99, Math.max(1, state.qty + Number(qtyBtn.dataset.qbQty)));
          return update();
        }
      });

      els.plans.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          state.plan = e.target.value;
          update();
        } else if (e.target === els.freqSelect) {
          state.sellingPlanId = Number(els.freqSelect.value);
          update();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) close();
      });

      els.submit.addEventListener('click', () => {
        const variant = currentVariant();
        if (!variant.available) return;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', state.qty);
        const isSub = state.plan === 'sub' && variant.sellingPlans.length > 0;
        if (isSub && state.sellingPlanId) formData.append('selling_plan', state.sellingPlanId);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
        }

        els.submit.disabled = true;
        els.submit.classList.add('loading');
        els.error.hidden = true;

        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              els.error.textContent = response.description || response.message || 'Something went wrong.';
              els.error.hidden = false;
              return;
            }
            if (!cart || typeof cart.renderContents !== 'function') {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'smack-cross-sell', productVariantId: variant.id, cartData: response });
            }
            opener = null;
            close();
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch((err) => {
            console.error(err);
            els.error.textContent = 'Something went wrong. Please try again.';
            els.error.hidden = false;
          })
          .finally(() => {
            els.submit.classList.remove('loading');
            update();
          });
      });
    }

    document.querySelectorAll('.smack-cross-sell').forEach(init);
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('.smack-cross-sell').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smack-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.smack-reviews').forEach((root) => {
      const tabs = root.querySelectorAll('[data-review-tab]');
      const cards = root.querySelectorAll('[data-review-card]');
      if (!tabs.length || !cards.length) return;

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const tag = tab.dataset.reviewTab;
          tabs.forEach((t) => {
            t.classList.toggle('is-selected', t === tab);
            t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
          });
          cards.forEach((card) => {
            card.hidden = !!tag && card.dataset.tag !== tag;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
